import AlarmClock from "./AlarmClock";
import Apple from "./Apple";
import AppleStore from "./AppleStore";
import BabyBoy from "./BabyBoy";
import BabyFeeder from "./BabyFeeder";
import BabyGirl from "./BabyGirl";
import BasketBall from "./BasketBall";
import BeautyProducts from "./BeautyProducts";
import Beer from "./Beer";
import Bottle from "./Bottle";
import Breakfast from "./Breakfast";
import Camera from "./Camera";
import Car from "./Car";
import Carrot from "./Carrot";
import CartIcon from "./Cart";
import CartBag from "./CartBag";
import CartCheck from "./CartCheck";
import CartX from "./CartX";
import Category from "./Category";
import CategoryOutlined from "./CategoryOutline";
import CreditCardVerified from "./CreditCardVerified";
import CustomerService from "./CustomerService";
import Delivery from "./Delivery";
import DeliveryBox from "./DeliveryBox";
import DottedStar from "./DottedStar";
import Dress from "./Dress";
import DrillMachine from "./DrillMachine";
import Eye from "./Eye";
import Facebook from "./Facebook";
import FacebookFilled from "./FacebookFilled";
import FeedbackThumbsUp from "./FeedbackThumbsUp";
import Figma from "./Figma";
import Food from "./Food";
import Gift from "./Gift";
import GiftBox from "./GiftBox";
import Globe from "./Globe";
import GoldPackageIcon from "./GoldPackageIcon";
import Google from "./Google";
import Heart from "./Heart";
import Honey from "./Honey";
import Instagram from "./Instagram";
import InstagramFilled from "./InstagramFilled";
import Laptop from "./Laptop";
import Light from "./Light";
import Lightning from "./Lightning";
import MakeUp from "./MakeUp";
import Man from "./Man";
import Microphone from "./Microphone";
import Milk from "./Milk";
import MoneyGuarantee from "./MoneyGurantee";
import MotorBike from "./MotorBike";
import NewArrival from "./NewArrival";
import OnlineService from "./OnlineService";
import OnlineSupport from "./OnlineSupport";
import PackageBox from "./PackageBox";
import Payment from "./Payment";
import Pen from "./Pen";
import Pets from "./Pets";
import PickUpBox from "./PickUpBox";
import Picture from "./Picture";
import PlantPot from "./PlantPot";
import PlayStore from "./PlayStore";
import PremiumPackageIcon from "./PremiumPackageIcon";
import Preview from "./Preview";
import Quote from "./Quote";
import RankBadge from "./RankBadge";
import Reload from "./Reload";
import Search from "./Search";
import Shield from "./Shield";
import ShoppingBagOutlined from "./ShoppingBagOutlined";
import SilverPackageIcon from "./SilverPackageIcon";
import Snack from "./Snack";
import SofaTwo from "./Sofa";
import Telegram from "./Telegram";
import Toggle from "./Toggle";
import Truck from "./Truck";
import TruckFast from "./TruckFast";
import TruckFilled from "./TruckFilled";
import Tshirt from "./Tshirt";
import Twitter from "./Twitter";
import TwitterFilled from "./TwitterFilled";
import UpDown from "./UpDown";
import User from "./User";
import User2 from "./User2";
import Verify from "./Verify";
import Vest from "./Vest";
import Watch from "./Watch";
import Wheel from "./Wheel";
import Woman from "./Woman";
import WomenDress from "./WomenDress";
import Yogurt from "./Yogurt";
import Youtube from "./Youtube";
import YoutubeFilled from "./YoutubeFilled";
import ArrowDownWide from "./ArrowDownWide";
import TireRuggedLight from "./TireRuggedLight";

import Home from "./Home";
import Sofa from "./furniture-shop/Sofa";
import Chair from "./furniture-shop/Chair";
import Stool from "./furniture-shop/Stool";
import Dining from "./furniture-shop/Dining";
import Living from "./furniture-shop/Living";
import Popular from "./furniture-shop/Popular";
import RoomSet from "./furniture-shop/RoomSet";
import Trending from "./furniture-shop/Trending";
import Products from "./furniture-shop/Products";
import Interior from "./furniture-shop/Interior";
import Wardrobe from "./furniture-shop/Wardrobe";
import Furniture from "./furniture-shop/Furniture";
import Decoration from "./furniture-shop/Decoration";
import RoundTable from "./furniture-shop/RoundTable";

import Toys from "./gift-shop/Toys";
import Robot from "./gift-shop/Robot";
import Flower from "./gift-shop/Flower";
import Children from "./gift-shop/Children";
import BabyToys from "./gift-shop/BabyToys";
import Football from "./gift-shop/Football";
import Christmas from "./gift-shop/Christmas";
import TeddyBear from "./gift-shop/TeddyBear";
import WeddingGift from "./gift-shop/WeddingGift";
import NewYearGift from "./gift-shop/NewYearGift";
import BirthdayCake from "./gift-shop/BirthdayCake";
import ValentineGift from "./gift-shop/ValentineGift";

import Powder from "./health-and-beauty/Powder";
import Lotion from "./health-and-beauty/Lotion";
import Mascara from "./health-and-beauty/Mascara";
import Lipstick from "./health-and-beauty/Lipstick";
import FaceMask from "./health-and-beauty/FaceMask";
import LenseCase from "./health-and-beauty/LenseCase";
import AutoMotive from "./health-and-beauty/Automotive";
import OxygenPump from "./health-and-beauty/OxygenPump";
import Thermometer from "./health-and-beauty/Thermometer";
import HealthBeauty from "./health-and-beauty/HealthBeauty";
import TeddyBearLight from "./TeddyBearLight";
import BasketShopping from "./BasketShopping";
import PawSimple from "./PawSimple";
import MicrophoneLines from "./MicrophoneLines";
import GiftLine from "./GiftLine";
import Trees from "./Trees";
import PersonBiking from "./PersonBiking";
import LaptopMobile from "./LaptopMobile";
import ShirtLine from "./ShirtLine";
import Desktop from "./Desktop";
import Microchip from "./Microchip";
import LaptopLight from "./LaptopLight";
import Gear from "./Gear";
import MobileNotch from "./MobileNotch";
import Tablet from "./Tablet";
import WatchApple from "./WatchApple";
import HouseSignal from "./HouseSignal";
import ChevronRight from "./ChevronRight";
const appIcons = {
  Beer,
  Milk,
  Snack,
  Truck,
  Honey,
  Apple,
  Shield,
  Bottle,
  Carrot,
  Yogurt,
  Payment,
  PickUpBox,
  Breakfast,
  AlarmClock,
  OnlineSupport,
  OnlineService,
  MoneyGuarantee,
  CustomerService,
  FeedbackThumbsUp,
  CreditCardVerified,
  Home,
  Sofa,
  Chair,
  Stool,
  Dining,
  Living,
  Popular,
  RoomSet,
  Trending,
  Products,
  Interior,
  Wardrobe,
  Furniture,
  Decoration,
  RoundTable,
  
// gift-shop-page-icons
  Toys,
  Robot,
  Flower,
  BabyToys,
  Children,
  Football,
  Chirstmas: Christmas,
  TeddyBear,
  WeddingGift,
  NewYearGift,
  BirthdayCake,
  ValentineGift,
  
// health-and-beauty-page-icons
  Powder,
  Lotion,
  Mascara,
  Lipstick,
  FaceMask,
  LenseCase,
  OxygenPump,
  AutoMotive,
  Thermometer,
  HealthBeauty,
  Car,
  Watch,
  Wheel,
  Camera,
  Tshirt,
  BabyBoy,
  Picture,
  BabyGirl,
  WomenDress,
  AppleStore,
  BabyFeeder,
  BasketBall,
  DrillMachine,
  BeautyProducts,
  CartIcon,
  CartCheck,
  CartX,
  Category,
  CategoryOutlined,
  Delivery,
  DeliveryBox,
  DottedStar,
  Dress,
  Eye,
  Facebook,
  FacebookFilled,
  Figma,
  Food,
  Gift,
  Globe,
  GoldPackageIcon,
  Google,
  GiftBox,
  Heart,
  Instagram,
  InstagramFilled,
  Laptop,
  Light,
  Lightning,
  MakeUp,
  Man,
  Microphone,
  MotorBike,
  NewArrival,
  PackageBox,
  Pen,
  Pets,
  PlantPot,
  PlayStore,
  PremiumPackageIcon,
  Preview,
  Quote,
  RankBadge,
  Reload,
  ShoppingBagOutlined,
  SilverPackageIcon,
  SofaTwo,
  Telegram,
  Toggle,
  TruckFast,
  TruckFilled,
  Twitter,
  TwitterFilled,
  UpDown,
  User2,
  Verify,
  Vest,
  Woman,
  Youtube,
  YoutubeFilled,
  Search,
  User,
  CartBag,
  ArrowDownWide,
  TireRuggedLight,
  TeddyBearLight,
  BasketShopping,
  PawSimple,
  MicrophoneLines,
  GiftLine,
  Trees,
  PersonBiking,
  LaptopMobile,
  ShirtLine,
  Desktop,
  Microchip,
  LaptopLight,
  Gear,
  MobileNotch,
  Tablet,
  WatchApple,
  HouseSignal,
  ChevronRight
};
export default appIcons;